import React from 'react'

export const ShefWorkshopIcon = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="217.023"
    height="37.895"
    viewBox="0 0 217.023 36.895"
  >
    <g
      id="Group_414"
      data-name="Group 414"
      transform="translate(667.266 166.319)"
    >
      <path
        id="Path_812"
        data-name="Path 812"
        d="M-540.392-129.731a.718.718,0,0,0,.476-.74l-.634-9.4a8.718,8.718,0,0,1,7.4-8.77l3.223-.264,14.211-.264,14.264-.106,14.264.106,14.212.317,14.264.476a3.988,3.988,0,0,0,3.064-1.585l1.638-3.17,1.426-3.223,1.163-3.381.9-3.434a2.544,2.544,0,0,0-.419-1.914,2.444,2.444,0,0,0-1.642-.992l-15.69.053-15.691.317-15.638.476-15.638.687-15.69.9-35.365,2.12-53.728,4.86-7.5.793-7.4,1-7.514,1.163a63.669,63.669,0,0,0-24.585,8.809l6.022,2.008,6.076,1.743,6.181,1.532,9.4,1.8,9.456,1.532,9.51,1.268,9.509,1,12.1,1.216,12.1,1.056,12.1.845,34.181,1.163"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_499"
        data-name="Line 499"
        x1="3.698"
        y1="12.838"
        transform="translate(-541.977 -158.471)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_813"
        data-name="Path 813"
        d="M-541.978-158.466a11.917,11.917,0,0,0-7.366-3.348"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_814"
        data-name="Path 814"
        d="M-527.607-152.66l-1.374.053-.211.053-.211.053-.159.106-.158.106-.159.159-.106.211-.106.211v.423"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_500"
        data-name="Line 500"
        y1="0.106"
        x2="2.219"
        transform="translate(-527.026 -152.818)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_501"
        data-name="Line 501"
        y1="0.159"
        x2="2.219"
        transform="translate(-524.226 -152.977)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_502"
        data-name="Line 502"
        y1="0.106"
        x2="2.272"
        transform="translate(-521.426 -153.082)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_503"
        data-name="Line 503"
        y1="0.106"
        x2="2.272"
        transform="translate(-518.626 -153.241)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_504"
        data-name="Line 504"
        y1="0.106"
        x2="2.272"
        transform="translate(-515.826 -153.346)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_505"
        data-name="Line 505"
        y1="0.106"
        x2="2.272"
        transform="translate(-513.026 -153.505)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_506"
        data-name="Line 506"
        y1="0.106"
        x2="2.272"
        transform="translate(-510.226 -153.663)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_507"
        data-name="Line 507"
        y1="0.106"
        x2="2.272"
        transform="translate(-507.426 -153.769)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_508"
        data-name="Line 508"
        y1="0.106"
        x2="2.219"
        transform="translate(-504.573 -153.928)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_509"
        data-name="Line 509"
        y1="0.158"
        x2="2.219"
        transform="translate(-501.773 -154.086)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_510"
        data-name="Line 510"
        y1="0.106"
        x2="2.219"
        transform="translate(-498.973 -154.192)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_511"
        data-name="Line 511"
        y1="0.106"
        x2="2.219"
        transform="translate(-496.173 -154.35)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_512"
        data-name="Line 512"
        y1="0.106"
        x2="2.219"
        transform="translate(-493.373 -154.456)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_513"
        data-name="Line 513"
        y1="0.106"
        x2="2.219"
        transform="translate(-490.573 -154.614)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_514"
        data-name="Line 514"
        y1="0.106"
        x2="2.272"
        transform="translate(-487.773 -154.773)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_515"
        data-name="Line 515"
        y1="0.106"
        x2="2.272"
        transform="translate(-484.973 -154.879)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_815"
        data-name="Path 815"
        d="M-482.173-154.931l1.374-.053.37-.106.37-.158.264-.211.053-.053"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_816"
        data-name="Path 816"
        d="M-479.373-155.988l.053-.053.159-.37.053-.37.053-.37-.053-1.691-.053-.37-.106-.317-.158-.317-.211-.264-.264-.211-.317-.158-.37-.106h-1.849"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_516"
        data-name="Line 516"
        x1="2.219"
        y2="0.053"
        transform="translate(-485.237 -160.584)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_517"
        data-name="Line 517"
        x1="2.219"
        transform="translate(-488.037 -160.531)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_518"
        data-name="Line 518"
        x1="2.219"
        transform="translate(-490.837 -160.479)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_519"
        data-name="Line 519"
        x1="2.272"
        y2="0.053"
        transform="translate(-493.69 -160.479)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_520"
        data-name="Line 520"
        x1="2.272"
        y2="0.053"
        transform="translate(-496.49 -160.426)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_521"
        data-name="Line 521"
        x1="2.272"
        transform="translate(-499.29 -160.373)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_522"
        data-name="Line 522"
        x1="2.272"
        transform="translate(-502.09 -160.32)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_523"
        data-name="Line 523"
        x1="2.219"
        y2="0.053"
        transform="translate(-504.89 -160.32)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_524"
        data-name="Line 524"
        x1="2.219"
        y2="0.053"
        transform="translate(-507.69 -160.267)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_525"
        data-name="Line 525"
        x1="2.219"
        transform="translate(-510.49 -160.214)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_526"
        data-name="Line 526"
        x1="2.272"
        transform="translate(-513.343 -160.162)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_527"
        data-name="Line 527"
        x1="2.272"
        y2="0.053"
        transform="translate(-516.143 -160.162)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_528"
        data-name="Line 528"
        x1="2.272"
        y2="0.053"
        transform="translate(-518.943 -160.109)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_529"
        data-name="Line 529"
        x1="2.272"
        transform="translate(-521.743 -160.056)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_530"
        data-name="Line 530"
        x1="2.219"
        y2="0.053"
        transform="translate(-524.543 -160.056)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_531"
        data-name="Line 531"
        x1="2.219"
        y2="0.053"
        transform="translate(-527.343 -160.003)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_817"
        data-name="Path 817"
        d="M-527.924-159.95h-1.743l-.264-.053-.211-.106-.158-.159-.211-.158-.106-.211-.106-.264v-.211"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_532"
        data-name="Line 532"
        x1="59.381"
        y2="1.902"
        transform="translate(-538.596 -157.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <path
        id="Path_818"
        data-name="Path 818"
        d="M-513.871-156.754a1.611,1.611,0,0,0-1.611-1.611,1.612,1.612,0,0,0-1.612,1.611,1.611,1.611,0,0,0,1.612,1.611,1.611,1.611,0,0,0,1.611-1.611"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_533"
        data-name="Line 533"
        x1="1.004"
        y1="14.733"
        transform="translate(-530.935 -163.642)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_534"
        data-name="Line 534"
        x1="1.004"
        y1="14.74"
        transform="translate(-527.184 -163.86)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
    </g>
  </svg>
)
